import documentsList from '../../views/list/redux/slice'
import documentsAndContractsEdittRedux from '../../modals/submitDocument/.config/redux/slice'

//export redux objects
export default {
	documentsList,
	documentsAndContractsEdittRedux
};